/** An airport's IATA code from its name as the server says it: `Tartu Airport (TAY)` is `TAY`. */
export function iataOf(name: string | undefined): string | null {
  return (name && /\(([A-Z]{3})\)$/.exec(name)?.[1]) ?? null;
}
